<template>
   <div class="modal fade" id="updateAffiliates" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="updateAffiliatesLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content bg-light">
            <div class="modal-header">
               <h5 class="modal-title" id="updateAffiliatesLabel">Actualizar Padrón de Afiliados</h5>
               <button type="button" class="btn-close" ref="btnClose" data-bs-dismiss="modal" aria-label="Close" :disabled="updating"></button>
            </div>
            <div class="modal-body">
               <div v-if="updating" class="card">
                  <div class="card-body text-center text-body-secondary">
                     <b><p class="card-text">El padrón de afiliados se está actualizado!</p></b>
                     <br>
                     <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                     </div>
                  </div>
               </div>
               <div v-else>
                  <div v-if="analyticalType.updating" class="card">
                     <div class="card-body">
                        <p class="card-text">El padrón de afiliados está siendo actualizado en este momento, vuelva a intentarlo mas tarde.</p>
                     </div>
                  </div>
                  <div v-else>
                     <b>Ultima Actualización:</b> {{ dateTime( analyticalType.updateDate ) }}
                     <br>
                     <b>Duración:</b> {{analyticalType.duration}}
                     <br>
                     <b>Registros Procesados:</b> {{ analyticalType.processed }}
                     <br>
                     <b>Registros Actualizados:</b> {{ analyticalType.updated }}
                     <br>
                     <b>Registros Borrados:</b> {{ analyticalType.deleted }}
                     <br>
                     <b>Registros Actuales del Padrón:</b> {{ analyticalType.totalRecords }}
                     <br>
                     <div v-if="updateErrors.length > 0">
                        <b>Registros con Errores:</b> {{ analyticalType.processed - analyticalType.updated }}
                        <table class="table table-sm">
                           <thead>
                              <tr>
                                 <th scope="col">#</th>
                                 <th scope="col">Error en</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(error, index) in updateErrors" :key="index" >
                                 <td>{{error.record}}</td>
                                 <td>{{error.errors}}</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
               <!--
               {{updateErrors}}
               {{analyticalType}}
                     <span class="spinner-border spinner-border-sm"></span>
               -->
            </div>
            <div class="modal-footer">
               <!-- <button type="button" class="btn btn-secondary" @click="closeModalJs()">Salir Js</button> -->
               <button type="button" 
                     class="btn btn-secondary" 
                     data-bs-dismiss="modal" 
                     :disabled="updating"
                     ref="btn_out_mdUpAffil"
                     >
                  Salir
               </button>
               <button v-if="!analyticalType.updating"
                     type="button" 
                     class="btn btn-primary" 
                     @click="updateAffiliates()" 
                     :disabled="updating">
                  Actualizar Padrón
               </button>
               <!--
               -->
            </div>
         </div>
      </div>
   <!--
   -->
   </div>
</template>

<script>

import { ref, onMounted } from 'vue'
import AnalyService from "../../analytics.service";

//import upVoucher310 from '/src/modules/voucher310/components/UpVoucher310.vue';
//src\modules\voucher310\components\UpVoucher310.vue

import useEventsBus from '/src/services/eventBus';

import moment from 'moment';

//import { useStore } from 'vuex'

//import content_ from './ContentTableTypeList.vue';

export default {
   components: {
  //    content_,
   //upVoucher310
   },
   setup() {

      const analyticalType = ref({})
      const updating = ref(false)
      const updateErrors = ref([])

      const {emiter} = useEventsBus()
      const btn_out_mdUpAffil = ref(null)

      onMounted(() => {
         document.getElementById('updateAffiliates')
         .addEventListener('show.bs.modal', function () {
            //let button = event.relatedTarget
            getAnalyticalType( "AFFIL" )
            //cellId.value = button.getAttribute('data-cell-id')
         })
      })
      
      function closeModalJs() {
         console.log('Salir Js')
         emiter('v310ToDo', 'upVouch')
         btn_out_mdUpAffil.value.click()
      }
      // D
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY HH:mm');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }
      // G
      function getAnalyticalType( code ) {
         AnalyService.getAnalyticalType( code )
            .then(response => {
               console.log(response.data)
               analyticalType.value = response.data
               getUpdateErrors( code )
            })
            .catch(error => {
               console.log(error);
            });
      }

      function getUpdateErrors( code ) {
         AnalyService.getUpdateErrors( code )
            .then(response => {
               console.log(response.data)
               updateErrors.value = response.data
            })
            .catch(error => {
               console.log(error);
            });
      }
      // U
      function updateAffiliates() {
         updating.value = true
         AnalyService.updateAffiliates()
            .then(response => {
               console.log(response.data)
               getAnalyticalType( "AFFIL" )
               updating.value = false
            })
            .catch(error => {
               console.log(error);
               updating.value = false
            });
      }
      
      return {
         analyticalType,
         btn_out_mdUpAffil,
         closeModalJs,
         dateTime,
         updateAffiliates, updating, updateErrors
      };
   }
}

</script>

<style scoped>
.pgnav {
    height: 38px;
}
.modal-dialog-scrollable .modal-content {
    /*max-height: 100%;*/
    height: 100%;
    overflow: hidden;
}
.modal-header .btn-close {
    padding: .5rem .5rem;
    margin: -.5rem -.5rem -.5rem -.5rem;
}
.opcBusqueda {
    padding: .5rem .5rem;
    margin: -.5rem 1.5rem -.5rem auto;
}
.el-del-medio {
   
   margin-left: auto;
   margin-right: auto;
   
}
.hgt-del-medio {
   height: 40px;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.cntt-resu {
   width: 210px;
}
   .bg-conteiner {
      /*background-color: rgba(0, 0, 0, .30);*/
      background-color: rgba(0, 0, 0, .50);
   }
</style>